module.exports = __webpack_public_path__ + "static/media/impact_program.5cd80af7.png";